var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLungsound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 66,
    viewBox: "0 0 66 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 33,
    cy: 33,
    r: 33,
    fill: "#6C60FF",
    fillOpacity: 0.18
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.6683 41.333C49.6666 47.9997 49.6666 47.9997 43.0016 47.9997C36.3366 47.9997 34.6683 42.9997 34.6683 37.9997C34.6683 37.3697 34.6383 36.4697 34.6249 35.4163L37.9966 37.3647L37.9999 37.9997C37.9999 42.6263 39.3599 44.6663 42.9999 44.6663C44.8999 44.6663 45.6833 44.6547 46.2716 44.603C46.3216 44.018 46.3333 43.233 46.3333 41.333C46.3333 35.9913 45.1616 31.278 43.2749 28.1663C41.8783 25.863 40.5866 25.0963 39.8883 25.328C39.3999 25.4913 38.8799 26.4113 38.5033 28.033L35.5199 26.3113C36.1349 24.3163 37.1566 22.7263 38.8333 22.1663C43.8333 20.4997 49.6733 28.833 49.6683 41.333ZM27.1666 22.1663C28.8449 22.7263 29.8666 24.3163 30.4816 26.3113L27.4983 28.033C27.1216 26.4113 26.5999 25.4913 26.1133 25.328C25.4133 25.0947 24.1216 25.8613 22.7266 28.1647C20.8383 31.278 19.6666 35.9913 19.6666 41.333C19.6666 43.233 19.6783 44.0163 19.7283 44.603C20.3166 44.6547 21.0999 44.6663 22.9999 44.6663C26.6399 44.6663 27.9999 42.6263 27.9999 37.9997L28.0066 37.363L31.3783 35.4163C31.3616 36.4713 31.3333 37.3697 31.3333 37.9997C31.3333 42.9997 29.6666 47.9997 22.9999 47.9997C16.3333 47.9997 16.3333 47.9997 16.3333 41.333C16.3333 28.833 22.1666 20.4997 27.1666 22.1663ZM34.6666 16.333V28.703L42.4932 33.223L40.8266 36.1097L32.9999 31.5913L25.1733 36.1097L23.5066 33.223L31.3333 28.703V16.333H34.6666Z",
    fill: "#6C60FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLungsound);
export default __webpack_public_path__ + "static/media/lungsound.9e8629d698d7e5e5311c5e609a1001f4.svg";
export { ForwardRef as ReactComponent };